import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type SaveDefaultViewResponce } from '../services/saveDeafultViewService'

export interface SaveDefaultViewDataState {
  isLoading: boolean
  loadingError: string | undefined
  SaveDefaultViewData: SaveDefaultViewResponce | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: SaveDefaultViewDataState = {
  isLoading: false,
  loadingError: undefined,
  SaveDefaultViewData: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const SaveDefaultViewDataListState = createSlice({
  name: 'SaveDefaultViewDetailsData',
  initialState,
  reducers: {
    SaveDefaultViewDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        SaveDefaultViewData: undefined,
        httpStatus: 0
      }
    },
    SaveDefaultViewDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        SaveDefaultViewData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    SaveDefaultViewDataErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        httpStatus: action.payload.httpStatus,
        SaveDefaultViewData: undefined
      }
    },
    SaveDefaultViewDataReset: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: false,
        loadingError: undefined,
        SaveDefaultViewData: undefined,
        httpStatus: 0
      }
    }
  }
})

// Actions to export
export const {
  SaveDefaultViewDataLoadingAction,
  SaveDefaultViewDataUpdateAction,
  SaveDefaultViewDataErrorAction,
  SaveDefaultViewDataReset
} = SaveDefaultViewDataListState.actions

export default SaveDefaultViewDataListState.reducer
